module.exports = __webpack_public_path__ + "img/project_pybullet.56047803.png";